import { IonToast } from "@ionic/react";
import {
  alertOutline,
  checkmarkOutline,
  closeOutline,
  informationOutline,
  warningOutline,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import "./CustomToast.css";
function CustomToast({ openToast, onDidDismiss, message, colorNotificacion }) {
  const [color, setColor] = useState("");
  const [icon, setIcon] = useState();
  const normalizedMessage =
    message === undefined || message === null ? "" : String(message).trim();
  const getColor = () => {
    switch (colorNotificacion) {
      case "verde":
        return "success";
      case "rojo":
        return "danger";
      case "amarillo":
        return "warning";
      default:
        return "primary";
    }
  };
  const getIcon = () => {
    switch (colorNotificacion) {
      case "verde":
        return checkmarkOutline;
      case "rojo":
        return alertOutline;
      case "amarillo":
        return warningOutline;
      default:
        return informationOutline;
    }
  };

  useEffect(() => {
    if (openToast) {
      setColor(getColor());
      setIcon(getIcon());
    }
  }, [openToast]);

  return (
    <IonToast
      isOpen={openToast && normalizedMessage.length > 0}
      onDidDismiss={onDidDismiss}
      message={normalizedMessage}
      duration={5000}
      position="top"
      className={`${color}`}
      icon={icon}
      buttons={[
        {
          icon: closeOutline,
          role: "cancel",
          handler: () => {
            onDidDismiss();
          },
        },
      ]}
    />
  );
}

export default CustomToast;
